
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PriceListDetailsGrid extends Serenity.EntityGrid<PriceListDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.PriceListDetails'; }
        protected getDialogType() { return PriceListDetailsDialog; }
        protected getIdProperty() { return PriceListDetailsRow.idProperty; }
        protected getInsertPermission() { return PriceListDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return PriceListDetailsRow.localTextPrefix; }
        protected getService() { return PriceListDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.autoHeight = true;
            return opt;
        }
    }
}